import DailySalesStore from './DailySalesStore';

export default DailySalesStore;
